import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: fit-content;
    background-color: #69707a;
    color: #fff;

    @media (max-width: 768px) {
        padding: 1rem;
    }
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 2rem 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
        padding: 1rem 0;
    }
`

export const StyledSelect = styled(Dropdown)`
    min-width: 20rem;
    width: max-content;
    height: fit-content;
    background-color: #ffffff;
    color: #000;
    border: none;
    margin-right: 1rem;

    @media (max-width: 768px) {
        width: 100% !important; /* override PrimeReact styles */
        min-width: unset;
        margin-left: 0;
        margin-right: 0;
    }
`

export const StyledSelectWithBackground = styled(StyledSelect)`
    .p-dropdown-label {
        background-color: #69707a;
        color: #fff;
        padding: 8px;
    }

    .p-dropdown-panel {
        background-color: #ffffff !important;
        color: #000;
    }
`

export const SelectEventText = styled.p`
    font-size: 20px;
    margin: 0;
    height: fit-content;
    color: #fff;
    width: 100%;

    @media (max-width: 480px) {
        font-size: 16px;
    }
`

export const SelectEventTextSmall = styled.p`
    font-size: 18px;
    margin: 0;
    height: fit-content;
    color: #fff;

    @media (max-width: 480px) {
        font-size: 16px;
    }
`

export const SelectEventWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    background-color: #8b949d;
    padding: 1rem 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 1rem;
        gap: 0.5rem;
    }
`

export const SelectWithButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;

    @media (max-width: 768px) {
        align-items: center;
        flex-direction: row;
    }
`

export const ButtonWrapper = styled.div`
    display: flex;
    gap: 1rem;

    @media (max-width: 768px) {
        justify-content: center;
        flex-wrap: wrap;
    }
`

export const SelectButton = styled(Button)`
    height: fit-content;
    background-color: #fff;
    color: #000;
`

export const AnimatedEventDetails = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'display',
})<{ display: boolean }>`
    opacity: ${({ display }) => (display ? 1 : 0)};
    max-height: ${({ display }) => (display ? '1000px' : '0')};
    overflow: hidden;
    transition:
        opacity 0.5s ease,
        max-height 0.5s ease;
    margin-top: 1rem;
`
